import UIManager from "../Shared/UIManager";
import AudioManager from "../Shared/AudioManager";
const i18n = require('LanguageData');

const { ccclass, property } = cc._decorator;

@ccclass
export class RateTips extends cc.Component {

    @property(cc.RichText)
    label0: cc.RichText = undefined;
    @property(cc.RichText)
    label1:cc.RichText = undefined;
    @property(cc.RichText)
    label2:cc.RichText = undefined;
    @property(cc.RichText)
    label3:cc.RichText = undefined;
    private _okCallback: () => void = undefined;
    //private _cancelCallback: () => void = undefined;

    //private _btnX: number = 0;


    onLoad() {
    }


    showTip(tips0: string,tips1: string,tips2: string,tips3: string, cb ? : ()=>void, textYes ? : string){
        this._okCallback = cb;
        this.node.active = true;
        this.label0.string = tips0;
        this.label1.string = tips1;
        this.label2.string = tips2;
        this.label3.string = tips3;
    }

    onClicked(event: cc.Event, param: string) {
        AudioManager.playSound("button");
        switch (param) {
            case 'ok':
                if (typeof this._okCallback === "function") {
                    this._okCallback();
                }
                break;
            case 'close':
                //this.node.destroy();
                break;
        }
        this._okCallback = undefined;
        //this._cancelCallback = undefined;
        // 关闭界面
        this.node.destroy();
    }
}
